import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import fr from "vuetify/src/locale/fr";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fr },
    current: "fr",
  },
  theme: {
    themes: {
      light: {
        primary: "#0a3b8e",
        secondary: "#8A7B60",
        accent: "#C6C6C6",
      },
    },
  },
});
